module.exports = __webpack_public_path__ + "img/reset_graph.dbb69125.svg";